import { render, staticRenderFns } from "./RealizedGainLossForm.vue?vue&type=template&id=7205fbf0&scoped=true"
import script from "./RealizedGainLossForm.vue?vue&type=script&lang=js"
export * from "./RealizedGainLossForm.vue?vue&type=script&lang=js"
import style0 from "./RealizedGainLossForm.vue?vue&type=style&index=0&id=7205fbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7205fbf0",
  null
  
)

export default component.exports